module.exports = __webpack_public_path__ + "static/img/1-1Z5231IZNX.c217a79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z5231IZNX.jpg
// module id = FP84
// module chunks = 0